import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[dhlAlphanumericField]'
})
export class AlphanumericFieldDirective {
  @Input() isAlphaNumeric!: boolean;
  regexStr = '^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9 ]*$';
  inputElement: HTMLInputElement;

  constructor(private readonly el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: any) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    this.inputElement.focus();
    event.preventDefault();
  }

  private validateFields(event: KeyboardEvent) {
    setTimeout(() => {
      this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^A-Za-z ]/g, '');
      event.preventDefault();
    }, 100);
  }
}
